import { useEffect, useState } from "react";
import { Sun, Moon } from "lucide-react";

const KEY = "kaizen_theme";
export const getTheme = () => { try { return localStorage.getItem(KEY) === "light" ? "light" : "dark"; } catch { return "dark"; } };
export const applyTheme = (t) => {
  document.documentElement.classList.toggle("theme-light", t === "light");
  try { localStorage.setItem(KEY, t); } catch { /* ignore */ }
  window.dispatchEvent(new CustomEvent("kaizen-theme", { detail: t }));
};

export function useTheme() {
  const [theme, setTheme] = useState(getTheme);
  useEffect(() => {
    applyTheme(theme);
    const h = (e) => setTheme(e.detail);
    window.addEventListener("kaizen-theme", h);
    return () => window.removeEventListener("kaizen-theme", h);
  }, [theme]);
  return [theme, (t) => setTheme(t || (theme === "light" ? "dark" : "light"))];
}

/** Bouton flottant pour le site public (l'app connectée a son propre réglage dans Confort de lecture). */
export default function ThemeToggle({ floating = true, className = "" }) {
  const [theme, toggle] = useTheme();
  const light = theme === "light";
  return (
    <button onClick={() => toggle()} data-testid="theme-toggle" title={light ? "Passer en mode sombre" : "Passer en mode clair"}
      aria-label={light ? "Mode sombre" : "Mode clair"}
      className={`${floating ? "fixed z-[70] bottom-[calc(env(safe-area-inset-bottom)+0.75rem)] left-3 sm:bottom-4 sm:left-4 h-9 w-9 sm:h-auto sm:w-auto justify-center sm:px-3 sm:py-2 opacity-70 hover:opacity-100" : "px-3 py-2"} inline-flex items-center gap-2 rounded-full border text-xs font-semibold shadow-lg backdrop-blur transition-[opacity,background-color] ${
        light ? "bg-white/90 border-black/10 text-zinc-900 hover:bg-zinc-100" : "bg-zinc-900/90 border-white/15 text-zinc-100 hover:bg-zinc-800"} ${className}`}>
      {light ? <Moon size={14} /> : <Sun size={14} />} <span className={floating ? "hidden sm:inline" : ""}>{light ? "Sombre" : "Clair"}</span>
    </button>
  );
}
